import axios from "../config/axios";

export const websiteService = {
  getPublic: () => axios.get("/website/public"),
  submitEnquiry: (payload) => axios.post("/website/public/enquiries", payload),
  submitComplaint: (payload) => axios.post("/website/public/complaints", payload),
  complaintStatus: (reference) => axios.get(`/website/public/complaints/${encodeURIComponent(reference)}`),
  submitMessage: (payload) => axios.post("/website/public/messages", payload),
  getManage: () => axios.get("/website/manage"),
  saveProfile: (payload) => axios.put("/website/profile", payload),
  saveBlock: (payload) =>
    payload.id ? axios.put(`/website/blocks/${payload.id}`, payload) : axios.post("/website/blocks", payload),
  deleteBlock: (id) => axios.delete(`/website/blocks/${id}`),
  saveBranch: (payload) =>
    payload.id ? axios.put(`/website/branches/${payload.id}`, payload) : axios.post("/website/branches", payload),
  deleteBranch: (id) => axios.delete(`/website/branches/${id}`),
  saveOption: (payload) =>
    payload.id ? axios.put(`/website/options/${payload.id}`, payload) : axios.post("/website/options", payload),
  deleteOption: (id) => axios.delete(`/website/options/${id}`),
  listCases: (type, params) => axios.get(`/website/cases/${type}`, { params }),
  getCase: (type, id) => axios.get(`/website/cases/${type}/${id}`),
  updateCase: (type, id, payload) => axios.patch(`/website/cases/${type}/${id}`, payload),
};
